module.exports = __webpack_public_path__ + "img/upgrade_member.2a28f712.svg";